<div class="px-3 py-2 border bg-light" style="overflow: hidden;">
    <div class="text-center">
        <a [routerLink]="['/watchfaces', watchface.id]">
            <code class="d-block">#{{ watchface.id }}</code>
            <img src="{{ watchface.image }}" width="200px" height="200px" class="rounded-circle" style="object-fit: cover;">
        </a>
    </div>
    <div class="text-end">
        <a href="{{ watchfacesStore }}#/detail?id={{ watchface.id }}">
            <i class="fas fa-external-link-alt"></i>
        </a>
    </div>
    <div>
        <div>
            <strong>{{ watchface.title }}</strong>
        </div>
        <div>{{ watchface.description }}</div>
        <div>
            <small>
                <div class="d-inline-block" *ngFor="let tag of watchface.tags">
                    <kbd class="me-1">
                        <i class="fas fa-tag align-middle"></i>&nbsp;{{ tag }}
                    </kbd>
                </div>
            </small>
        </div>
        <div>
            <span class="me-1">
                {{ watchface.numDownloads }} <i class="fas fa-cloud-download-alt"></i>
            </span>
            <span class="me-1">
                {{ watchface.numShares }} <i class="fas fa-share-square"></i>
            </span>
        </div>
        <div>
            <span class="me-1">
                <i *ngFor="let x of [1, 2, 3, 4, 5]" [class.fas]="x <= watchface.rating" [class.far]="x > watchface.rating" class="fa-star"></i>
            </span>
            <span class="me-1">
                <small>
                    ({{ watchface.numRatings }} <i class="fas fa-users"></i>)
                </small>
            </span>
        </div>
        <div>
            <small class="text-muted">{{ watchface.datetime | date: 'yyyy-MM-dd HH:mm UTC' : 'UTC' }}</small>
        </div>
        <div class="small">
            <button class="btn btn-sm btn-outline-success align-middle me-1" [disabled]="watchface.status == 'APPROVED'" (click)="emitApproveEvent()" *ngIf="approve">Approve</button>
            <button class="btn btn-sm btn-outline-danger align-middle me-1" [disabled]="watchface.status == 'REJECTED'" (click)="emitRejectEvent()" *ngIf="reject">Reject</button>
            <span class="d-inline-block text-truncate align-middle">{{ watchface.status }}</span>
        </div>
        <!--div>deleted: {{ watchface.deleted }}</div-->
        <!--div>ignoreReport: {{ watchface.ignoreReport }}</div-->
        <hr class="my-1">
        <div>
            <a [routerLink]="['/users', watchface.user.id]">
                <a *ngIf="watchface.user.name != null && watchface.user.name.trim().length > 0">
                    {{ watchface.user.name }}
                </a>
                <a *ngIf="watchface.user.name == null || watchface.user.name.trim().length == 0">
                    User <code>#{{ watchface.user.id }}</code>
                </a>
            </a>
        </div>
    </div>
</div>